var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/followingArtist.492ab0a8.png","uri@2x": __webpack_public_path__ + "static/media/followingArtist.7002a147.png","uri@3x": __webpack_public_path__ + "static/media/followingArtist.8eff4f3a.png",
    width: 42,
    height: 27
});